import {CookieUtil} from './cookieUtil';

( function( app ) {
  const COMPONENT = {
    className: 'announcement-banner',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      const debounce = require( 'lodash/debounce' );

      const $banner = $( '#announcement-banner' );
      const $root = $( ':root' );
      const $closeButton = $( '#announcement-banner__close' );
      const $mobileCta = $( '#mobile-cta' );

      function getElementHeight( el ) {
        if ( !el || !el.offsetHeight ) return 0;
        return el.offsetHeight;
      }

      function updateBannerHeight() {
        const height = getElementHeight( $banner[0] );
        $root.css( '--announcementBannerHeight', `${height}px` );
      }

      function updateMobileCtaHeight() {
        const isMobile = window.matchMedia( '(max-width:1023px)' ).matches;
        if ( !isMobile ) {
          $root.css( '--mobileCtaHeight', '0px' );
          return;
        }
        const height = getElementHeight( $mobileCta[0] );
        $root.css( '--mobileCtaHeight', `${height}px` );
      }

      function updateHeights() {
        updateBannerHeight();
        updateMobileCtaHeight();
      }

      function openAnnouncementBanner() {
        $banner.show( 0, () => {
          updateHeights();
          void $root[0].offsetHeight; // force reflow
        } );
      }

      function closeAnnouncementBanner() {
        $banner.hide( 0, () => {
          updateHeights();
          void $root[0].offsetHeight; // force reflow
        } );
      }

      // Initial render
      updateHeights();

      // Recalculate on resize
      $( window ).on(
          'resize',
          debounce( () => {
            updateHeights();
          }, 100 ),
      );

      // Session storage
      if ( !sessionStorage.getItem( 'll-announcement-banner-seen' ) ) {
        sessionStorage.setItem( 'll-announcement-banner-seen', 'false' );
      }
      if ( sessionStorage.getItem( 'll-announcement-banner-seen' ) === 'false' ) {
        openAnnouncementBanner();
      }

      $closeButton.on( 'click', function() {
        closeAnnouncementBanner();
        sessionStorage.setItem( 'll-announcement-banner-seen', 'true' );
      } );
    },

    finalize: function() {},
  };

  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
